import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Download, Calendar } from "lucide-react";

export default function Reports() {
  const [startDate, setStartDate] = useState(() => {
    const d = new Date(); d.setDate(d.getDate() - 7);
    return d.toISOString().slice(0, 10);
  });
  const [endDate, setEndDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/puantaj/history", { params: { start_date: startDate, end_date: endDate } });
      setHistory(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const downloadTodayExcel = async () => {
    const token = localStorage.getItem("jarvis_token");
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reports/export-today`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `arsi_puantaj_${new Date().toISOString().slice(0, 10)}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // Aggregate counts per date
  const summary = {};
  history.forEach((h) => {
    const key = h.date;
    if (!summary[key]) summary[key] = { date: key, total: 0, counts: { CALISIYOR: 0, IZINLI: 0, RAPORLU: 0, HAFTA_TATILI: 0, UCRETSIZ_IZIN: 0, GELMEDI: 0 } };
    h.entries?.forEach((e) => {
      summary[key].total++;
      summary[key].counts[e.status] = (summary[key].counts[e.status] || 0) + 1;
    });
  });
  const summaryRows = Object.values(summary).sort((a, b) => b.date.localeCompare(a.date));

  return (
    <div className="max-w-6xl mx-auto">
      <h1 className="font-display text-xl font-bold text-cyan-300 tracking-widest uppercase mb-5 text-glow-sm">Raporlar</h1>

      <div className="glass-card hud-corners p-5 mb-5">
        <div className="flex flex-wrap gap-3 items-end">
          <div>
            <label className="block text-[10px] font-mono text-cyan-300/70 uppercase tracking-widest mb-1">Başlangıç</label>
            <input data-testid="start-date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)}
                   className="px-3 py-2 bg-slate-950/60 border border-cyan-500/30 rounded-lg text-sm text-white font-mono" />
          </div>
          <div>
            <label className="block text-[10px] font-mono text-cyan-300/70 uppercase tracking-widest mb-1">Bitiş</label>
            <input data-testid="end-date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)}
                   className="px-3 py-2 bg-slate-950/60 border border-cyan-500/30 rounded-lg text-sm text-white font-mono" />
          </div>
          <button data-testid="filter-btn" onClick={load} className="btn-cyan px-5 py-2 rounded-lg font-mono text-xs uppercase tracking-widest">
            <Calendar className="w-4 h-4 inline mr-2" /> Filtrele
          </button>
          <button data-testid="download-excel" onClick={downloadTodayExcel} className="btn-cyan px-5 py-2 rounded-lg font-mono text-xs uppercase tracking-widest ml-auto">
            <Download className="w-4 h-4 inline mr-2" /> Bugünün Excel'i
          </button>
        </div>
      </div>

      <div className="glass-card p-4">
        <h3 className="font-display text-sm font-bold text-cyan-300 tracking-widest uppercase mb-3">Günlük Özet</h3>
        {loading && <div className="text-center py-6 font-mono text-cyan-400">Yükleniyor...</div>}
        {!loading && summaryRows.length === 0 && (
          <div className="text-center py-10 text-slate-500 font-mono text-sm">Bu tarih aralığında kayıt bulunmuyor</div>
        )}
        {!loading && summaryRows.length > 0 && (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="text-[10px] font-mono text-cyan-300/70 uppercase tracking-widest border-b border-cyan-500/20">
                  <th className="text-left py-2">Tarih</th>
                  <th className="text-right py-2">Toplam</th>
                  <th className="text-right py-2 text-emerald-300">Çalışıyor</th>
                  <th className="text-right py-2 text-cyan-300">İzinli</th>
                  <th className="text-right py-2 text-amber-300">Raporlu</th>
                  <th className="text-right py-2 text-sky-300">Hafta T.</th>
                  <th className="text-right py-2 text-rose-300">Gelmedi</th>
                </tr>
              </thead>
              <tbody>
                {summaryRows.map((r) => (
                  <tr key={r.date} className="border-b border-cyan-500/10 font-mono">
                    <td className="py-2 text-cyan-200">{r.date}</td>
                    <td className="py-2 text-right text-slate-200">{r.total}</td>
                    <td className="py-2 text-right text-emerald-300">{r.counts.CALISIYOR || 0}</td>
                    <td className="py-2 text-right text-cyan-300">{r.counts.IZINLI || 0}</td>
                    <td className="py-2 text-right text-amber-300">{r.counts.RAPORLU || 0}</td>
                    <td className="py-2 text-right text-sky-300">{r.counts.HAFTA_TATILI || 0}</td>
                    <td className="py-2 text-right text-rose-300">{r.counts.GELMEDI || 0}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
